<template>
  <div class="setting-advanced-voice">
    <div class="setting-advanced-voice-tips" v-if="showMsgTips">
      <p>在微信浏览器中使用发送语音消息需要配置企业公众号的 APPID 和 APPSECRET，设置时请将 chat.weiliaokefu.com 设为微信JS接口安全域名，并将IP 101.37.204.176
        设置到公众号白名单中</p>
      <svg-icon icon-class="close" class="tips-close-btn" @click.native="closeTips"></svg-icon>
    </div>
    <div class="module-item-style">
      <div class="module-item-title">上传微信验证文件</div>
      <div class="setting-advanced-upload-container">
        <div class="upload-input">
          <div class="file-name-div">{{selectedFileName}}</div>
          <input type="file" @change="fileChange" v-show="false" ref="fileInput">
          <div class="chose-file" @click="chooseFile">选择文件</div>
        </div>
        <div class="uploaded-file" v-if="uploadedFile.length > 0">已上传文件：{{uploadedFile}}</div>
        <div class="upload-btn">
          <span class="wl-btn" @click="uploadWxFile">上传</span>
        </div>
      </div>
    </div>
    <div class="module-item-style">
      <div class="module-item-title">主公众号</div>
      <el-form :model="wxForm" :rules="wxFormRules" ref="wxForm" label-width="130px" class="wxForm-style">
        <el-form-item label="APP ID:" prop="appId">
          <el-input v-model="wxForm.appId"></el-input>
        </el-form-item>
        <el-form-item label="APP SECRET:" prop="appSecret">
          <el-input v-model="wxForm.appSecret"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="wxSave('wxForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'setting-advanced-voice',
    data() {
      return {
        showMsgTips: true,
        selectedFileName:'',
        uploadFileData:null,
        wxForm:{
          appId:'',
          appSecret:''
        },
        wxFormRules:{
          appId: [
            { required: true, message: '请填写APP ID', trigger: 'blur' }
          ],
          appSecret: [
            { required: true, message: '请填写APP SECRET', trigger: 'blur' }
          ]
        },
        uploadedFile:''
      }
    },
    created() {
      this.getVoiceConfig()
      this.getWxFile()
    },
    mounted() {
      // TODO 上传验证文件，获取上传的验证文件
    },
    methods: {
      closeTips(){
        this.showMsgTips = false
      },
      getVoiceConfig(){
        this.$http.gzhInfoAPI().then( res => {
          if(res.status == 1){
            this.wxForm = res.data
          }
        })
      },
      chooseFile() {
        this.$refs.fileInput.click()
      },
      fileChange(e) {
        let file = e.target.files[0]
        this.selectedFileName = file.name
        let formData = new FormData();
        formData.set("file",file)
        this.uploadFileData = formData
      },
      uploadWxFile(){
        if(!this.uploadFileData){
          this.$message({
            message: '请选择要上传的文件',
            type: 'error',
          })
          return false
        }
        this.$http.uploadWxFileAPI(this.uploadFileData).then( res => {
          if(res.status == 1){
            this.getWxFile()
            this.selectedFileName = ''
            this.uploadFileData = null
            this.$message({
              message: res.msg,
              type: 'success',
            })
            this.getVoiceConfig()
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
      getWxFile(){
        this.$http.getWxFileAPI().then(res => {
          if(res.status == 1){
            this.uploadedFile = res.data
          }
        })
      },
      wxSave(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$http.saveGzhInfoAPI(this.wxForm).then( res => {
              if(res.status == 1){
                this.$message({
                  message: res.msg,
                  type: 'success',
                })
                this.getVoiceConfig()
              }else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                })
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    }
  }
</script>

<style lang="scss">
.setting-advanced-voice{
  .setting-advanced-voice-tips{
    border-radius: $mainBorderRadius;
    background-color: #fff2d7;
    border: 1px solid #ffdf9c;
    margin-bottom: 10px;
    line-height: 20px;
    font-size: 12px;
    color: #666;
    display: flex;
    padding: 15px 19px;
    position: relative;
    .tips-close-btn{
      position: absolute;
      right: 0px;
      top: 50%;
      margin-top: -9px;
      cursor: pointer;
    }
  }
  .setting-advanced-upload-container{
    padding-top: 20px;
    .uploaded-file{
      padding: 10px 0 0;
      font-size: 12px;
    }
    .upload-input {
      width: 500px;
      border: 1px solid #E4E7ED;
      border-radius: $mainBorderRadius;
      line-height: 40px;
      display: flex;
      margin-right: 30px;

      .file-name-div {
        flex: 1;
        font-size: 12px;
        color: #999;
        padding: 0 15px;
      }

      .chose-file {
        width: 78px;
        text-align: center;
        font-size: 12px;
        color: #333;
        cursor: pointer;
        background-color: #F2F2F2;
      }
    }
    .upload-btn{
      padding-top: 20px;
    }
  }
  .wxForm-style{
    width: 600px;
    padding-top: 20px;
    .el-form-item__label{
      font-weight: bold;
      color: #333;
    }
  }
}
</style>
